module.exports = __webpack_public_path__ + "static/sport/bg-h5.82af71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/bg-h5.jpg
// module id = YKLF
// module chunks = 0